<template>
  <span class="checkbox-component">
    <span
      class="checkbox"
      :class="{'checked': isChecked, 'disabled': disabled, 'disabled-checked': isChecked && disabled}"
      @click="handleClick"
    ></span>
    <span class="label">{{ label }}</span>
    <span class="extra" v-if="$children.length">
      <slot />
    </span>
  </span>
</template>
<script>
import emitter from '@/utils/emitter';
export default {
  name: 'radio-item',
  data() {
    return {
      selfIsChecked: false,
    };
  },
  mixins: [emitter],
  methods: {
    handleClick() {
      if (this.isGroup) {
        this.$parent.onChange(this.value);
        // console.log('checkbox-group', 'input', this.value);
        // this.dispatch('checkbox-group', 'input', this.value);
        // this.dispatch('checkbox-group', 'change', this.value);
      } else {
        this.selfIsChecked = !this.selfIsChecked;
        this.$emit('change', new Event('onChange', {
          target: {
            value: this.value,
            checked: this.selfIsChecked,
          },
        }));
        this.$emit('input', this.selfIsChecked);
      }
    }
  },
  computed: {
    isChecked() {
      return this.isGroup ? this.value === this.$parent.checkedValue : this.selfIsChecked;
    },
    isGroup() {
      return this.$parent.$options.name === 'radio-group';
    },
  },
  props: {
    value: {
      type: [Number, String, Boolean],
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../style';
</style>